import React, { ReactElement, ReactNode } from 'react';

type MyPaperProps = {
    children: ReactNode;
};

export function MyPaper(props: MyPaperProps): ReactElement {
    return <div className="shadow-sm rounded bg-white p-2 mb-2">{props.children}</div>;
}
